module.exports = __webpack_public_path__ + "img/15.71642a2a.jpg";